import React from 'react';
import { ErrorListProps } from '@rjsf/utils';

import { GenericContext } from 'shared/constants';

// eslint-disable-next-line import/no-default-export
export default function ErrorList(props: ErrorListProps) {
  const { errors } = props;

  const { settings } = React.useContext(GenericContext) as any;

  const skillsSetFieldsWithDot = Object.keys(settings.frontendCustomWidgetsOptions || {}).map(
    (skillsSetField) => `.${skillsSetField}`,
  );

  return (
    <div>
      <ul>
        {errors.map((error) => (
          <li className="text-danger" key={error.stack}>
            {skillsSetFieldsWithDot.includes(error.property) ? error.message : error.stack}
          </li>
        ))}
      </ul>
    </div>
  );
}
